import { EntityType } from '../../../types/comment';
import React, { useContext } from 'react';
import { TableSettingsContext } from '../../../context/TableSettingsContext';
import LoadingPackage from '../../pages/Common/LoadingPackage';
import { CustomFieldEntityType } from '../../../types/custom_field';
import NotFound from '../../components/NotFound/NotFound';
import { CompanyContext } from '../../../context/CompanyContext';
import TableSettingsContent from './TableSettingsContent';

export interface TableSettingsViewProps<T> {
  type: EntityType;
  parentType?: EntityType;
  customFieldEntityType?: CustomFieldEntityType;
  availableColumns?: T[];
  columnTextBuilder: (column: T) => string;
  label: string;
  placeholder: string;
}

export default function TableSettingsView<T>({
  type,
  parentType,
  customFieldEntityType,
  availableColumns,
  columnTextBuilder,
  label,
  placeholder,
}: TableSettingsViewProps<T>) {
  const { currentCompany } = useContext(CompanyContext);
  const { tableSettingsLoading, getTableSettings } = useContext(TableSettingsContext);

  if (tableSettingsLoading) {
    return (
      <div className='flex h-full items-center justify-center'>
        <LoadingPackage />
      </div>
    );
  }

  const tableSettings = getTableSettings(type, currentCompany.id, parentType);

  if (!tableSettings) return <NotFound />;

  return (
    <TableSettingsContent
      settings={tableSettings}
      customFieldEntityType={customFieldEntityType}
      availableColumns={availableColumns}
      columnTextBuilder={columnTextBuilder}
      label={label}
      placeholder={placeholder}
    />
  );
}
